
// Webpack Imports
import * as bootstrap from 'bootstrap';

jQuery(document).ready(function($) {

(function() {
    'use strict';
    console.log('opa');

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function(e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function(popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });
})();


if($('body').hasClass('single-post')){
  var wWindow = $(window).width();

  if(wWindow < 641) {
    jQuery('nav.rank-math-breadcrumb').appendTo('.bMobile');
  }

  $( window ).resize(function() {
    var wWindow2 = $(window).width();
    if(wWindow2 < 641) {
      jQuery('nav.rank-math-breadcrumb').appendTo('.bMobile');
    } else {
      jQuery('nav.rank-math-breadcrumb').appendTo('body.single-post .contentPost .breadcrumbs');
    }
  });
}


$('.section-price .tabs-packages__single .tabs-packages__name h3').on('click', function(){
  $('.tabs-packages__single').removeClass('active');
  $('.tabs-packages__content').slideUp();
  $(this).closest('.tabs-packages__single').addClass('active');
  $(this).closest('.tabs-packages__single').find($('.tabs-packages__content')).slideDown();
})

if($('body').hasClass('single-post')) {

  $(window).scroll(function() {

    // calculate the percentage the user has scrolled down the page
    var scrollwin = $(window).scrollTop();
    var articleheight = $('.contentPost').outerHeight(true);
    var windowWidth = $(window).width();
    if (scrollwin >= $('.contentPost').offset().top) {
        if (scrollwin <= ($('.contentPost').offset().top + articleheight)) {
            $('.bar-long').css('width', ((scrollwin - $('.contentPost').offset().top) / articleheight) * 100 + "%");
        } else {
            $('.bar-long').css('width', "100%");
        }
    } else {
        $('.bar-long').css('width', "0px");
    }


});
}



  
  
$(window).on('scroll', function(){
  function isScrollIntoView(elem, index) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(window).height()*.5;
    if(elemBottom <= docViewBottom && elemTop >= docViewTop) {
      $(elem).addClass('active');
    }
    if(!(elemBottom <= docViewBottom)) {
      $(elem).removeClass('active');
    }
    var MainTimelineContainer = $('.processContentLeft')[0];
    var MainTimelineContainerBottom = MainTimelineContainer.getBoundingClientRect().bottom - $(window).height()*.5;
    $(MainTimelineContainer).find('.inner').css('height',MainTimelineContainerBottom+'px');
  }
  var timeline = $('.processContentLeft .processContentLeft-single');
  Array.from(timeline).forEach(isScrollIntoView);
});


$(window).on('scroll', function(){
  function isScrollIntoView(elem, index) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(window).height()*.5;
    if(elemBottom <= docViewBottom && elemTop >= docViewTop) {
      $(elem).addClass('active');
    }
    if(!(elemBottom <= docViewBottom)) {
      $(elem).removeClass('active');
    }
    var MainTimelineContainer = $('.processTable')[0];
    var MainTimelineContainerBottom = MainTimelineContainer.getBoundingClientRect().bottom - $(window).height()*.6;
    $(MainTimelineContainer).find('.inner').css('height',MainTimelineContainerBottom+'px');
  }
  var timeline = $('.sectionProcessRealizacji .colContent');
  Array.from(timeline).forEach(isScrollIntoView);
});
  
  

$(document).ready(function() {
  var indexNav = 1;
  $('#content section').each(function(){
      if($(this).attr('data-attr') != '') {
        if(indexNav == 1) {
          var classAdd = 'active';
        } else {
          var classAdd = 'no-active';
        }
          console.log($(this).attr('data-name'));
          $('#navList').append('<li class="'+ classAdd +'"  ><a data-id="'+$(this).attr('data-attr')+'" href="#'+$(this).attr('data-attr')+'">'+$(this).attr('data-name')+'</li>');
          indexNav++;
      }
  });

  var section = document.querySelectorAll(".section-page");
  var sections = {};
  var i = 0;

 

  Array.prototype.forEach.call(section, function (e) {
      sections[e.id] = e.offsetTop;
  });



  window.onscroll = function () {
      var scrollPosition = document.documentElement.scrollTop + 700 ||
          document.body.scrollTop + 700;


      for (i in sections) {
          if (sections[i] <= scrollPosition) {
              $('#navList li').removeClass('active');
              $('#navList li a[data-id="' + i + '"]').parent().addClass('active');
              // document.querySelector('a[data-id="' + i + '"]').parentElement.setAttribute('class', 'active');
          } 
      } 


    
  };

  



if( $('body').hasClass('single-post') ) {
  var sectionb = document.querySelectorAll(".heading-anchor")
var sectionsb = {};
var b = 0;

Array.prototype.forEach.call(sectionb, function (e) {
  sectionsb[e.id] = e.offsetTop;
});

window.onscroll = function () {


  var scrollPositionb = document.documentElement.scrollTop - 320 || document.body.scrollTop - 320;



  for (b in sectionsb) {
      if (sectionsb[b] <= scrollPositionb) {
   
        $('.post-content__table-of-contents ul li a').removeClass('active');
        $('.post-content__table-of-contents ul li a#' + b + '').addClass('active');
          // document.querySelector('a[data-id="' + i + '"]').parentElement.setAttribute('class', 'active');
      } 
  } 


};
}


$('.callForm, .show-contact, a[href="#show-contact"]').on('click', function(e){
  $('.callFormContent').addClass('show');
  e.preventDefault();
})

$('.callFormContent .closeForm img').on('click', function(){
  $('.callFormContent').removeClass('show');
})

$('body.single-post .contentListMobile span.action').on('click', function(){
  var text = $('body.single-post .contentListMobile span.action').text();
  if(text == 'Rozwiń') {
    $('body.single-post .contentListMobile span.action').text('Zwiń');
  } 
  if(text == 'Zwiń') {
    $('body.single-post .contentListMobile span.action').text('Rozwiń');
  }
  $('body.single-post .contentListMobile ul').slideToggle();
})


if($('body').hasClass('single-casestudy')){
  var b = 0;
$(window).scroll(function () {
    var bTop = $(".caseContent").offset().top - window.innerHeight + 300;
    if (b == 0 && $(window).scrollTop() > bTop) {
      $(".circle_percent").each(function() {
        var $this = $(this),
        $dataC = $this.data("content"),
        $dataV = $this.data("percent"),
        $dataDeg = $dataV * 3.6,
        $round = $this.find(".round_per");
        $round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");	
        $this.append('<div class="circle_inbox"><span class="percent_text"></span></div>');
        $this.prop('Counter', 0).animate({Counter: $dataC},
        {
          duration: 2000, 
          easing: 'swing', 
          step: function (now) {
                  $this.find(".percent_text").text(Math.ceil(now)+"%");
              }
          });
        if($dataV >= 51){
          $round.css("transform", "rotate(" + 360 + "deg)");
          setTimeout(function(){
            $this.addClass("percent_more");
          },1000);
          setTimeout(function(){
            $round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");
          },1000);
        } 
        });
      
        b = 1;
    }
});

}





  $(document).on('click', '#navList a[href^="#"]', function(e) {
    // target element id
    var id = $(this).attr('href');

    // target element
    var $id = $(id);
    if ($id.length === 0) {
        return;
    }

    // prevent standard hash navigation (avoid blinking in IE)
    e.preventDefault();

    // top position relative to the document
    var pos = $id.offset().top - 100

    // animated top scrolling
    $('body, html').animate({scrollTop: pos});
});


$(document).on('click', '.post-content__table-of-contents ul li  a[href^="#"], .contentListMobile ul li a[href^="#"]', function(e) {
  // target element id
  var id = $(this).attr('href');
 
  // target element
  var $id = $('.contentPostExc ' + id);
  if ($id.length === 0) {
      return;
  }

  // prevent standard hash navigation (avoid blinking in IE)
  e.preventDefault();

  // top position relative to the document
  var pos = $id.offset().top - 150

  // animated top scrolling
  $('body, html').animate({scrollTop: pos});
});

  

      $('.nav-header .colBtn a, .buttonMobile a, .show-consultation, a[href="#show-consultation"]').on('click', function(e){
        $('.popupForm').addClass('show');
        e.preventDefault();
      })
      $('.popupForm-close').on('click', function(){
        $('.popupFormEnd').addClass('show');
      })

      $('.popupFormEnd .popupFormEnd-content .closeEnd img').on('click', function(){
        $('.popupForm').removeClass('show');
        $('.popupFormEnd').removeClass('show');
      })

        $('#nav-icon3').click(function(){
            $(this).toggleClass('open');
            $('.nav-header .colNav').toggleClass('openedNavMobile');
        });

        $('.nav-header .colNav > div > ul > li.megamenu-trigger > a').append('<img src="/wp-content/uploads/2022/11/arrow-normal.svg" class="d-xl-none arrowMenu"/>');
        $(document.body).on('click', '.nav-header .colNav > div > ul > li > a .arrowMenu', function(){
            $(this).parent().next().slideToggle();
            $(this).parent().parent().toggleClass('openedMobile');
        })

        $('a[href="#newsletter-sign"]').on('click', function(e){
          e.preventDefault();
          $('body').addClass('overflow-hidden');
          jQuery('.newsletter-pop').addClass('show');
        })
        $('.newsletter-pop .formContent .closeEnd img').on('click', function(){
          $('body').removeClass('overflow-hidden');
          jQuery('.newsletter-pop').removeClass('show');
        })

        $(window).scroll(function () { 
          if( $(window).scrollTop() > 0 ) {
            $('.nav-header').addClass('fixedNav');
          } else {
            $('.nav-header').removeClass('fixedNav');
          }
        })
  


    $(".hamburger").click(function() {
        $(this).toggleClass("is-active");
        $('.nav-side').toggleClass("show");
    });

    $('.tabContent .rowNav .col').on('click', function(){
        var getId = $(this).attr('id');
        $('.tabContent .rowNav .col').removeClass('active');
        $(this).addClass('active');

     

        $('.tabContent .rowContent .rowContentSingle').slideUp();
        $('.tabContent .rowContent .rowContentSingle#' + getId).slideDown();


        $('.tabContent .tabContentMobile').slideUp();
        $(this).next().slideDown();
        
    })




    if($('section.opinionPartner').length > 0) {
        var swiper = new Swiper(".swiperOpinion", {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            breakpoints: {
              992: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            },
          });
        }
    if($('.sectionTech').length > 0) {
        var swiper = new Swiper(".swiperTech", {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            breakpoints: {
              992: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 6,
                spaceBetween: 20,
              },
            },
          });
    }

    if($('section.caseContent').length > 0) {
        var swiper = new Swiper(".swiperClients", {
          loop: true,
          // speed: 1000,
          // autoplay: {
          //     delay: 3000,
          // },
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          coverflowEffect: {
              rotate: 0,
              stretch: 80,
              depth: 200,
              modifier: 1,
              slideShadows: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          on: {
            click(event) {
                console.log('event.target',this.clickedIndex);
                swiper.slideTo(this.clickedIndex);	
            },
          },
      
          // Navigation arrows
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
          });
    }


    if($('section.blogSlider').length > 0) {
        var swiper = new Swiper(".swiperBlog", {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            breakpoints: {
              992: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            },
          });
    }
 

    $('.faqContent .faqRight .singleQuestion-top').on('click', function(){
      if($(this).parent().hasClass('active')){
        $('.faqContent .faqRight .singleQuestion-bottom').slideUp();
        $('.faqContent .faqRight .singleQuestion').removeClass('active');

      }else {
        $('.faqContent .faqRight .singleQuestion-bottom').slideUp();
        $('.faqContent .faqRight .singleQuestion').removeClass('active');
        $(this).parent().addClass('active');
        $(this).next().slideDown();
      }
    })
 

    $('.contactDataForm .formCol .tabContentForm .tab').on('click', function(){
      $('.contactDataForm .formCol .tabContentForm .tab').removeClass('active')
      $(this).addClass('active');
      if( $('.tab-2').hasClass('active') ){
        $('.hideBox').show();
      } else {
        $('.hideBox').hide();
      }
    })


    $('.faqContent .navigationFaq .rowNav .navigationFaq-single').on('click', function(){
      $('.faqContent .navigationFaq .rowNav .navigationFaq-single').removeClass('active');

      $(this).addClass('active');
      var getType = $(this).find('a').attr('data-href');
      $('.singleQuestion').hide();

       $('.singleQuestion.' + getType).show();
       jQuery(".txtInput").val('');
      })

      $('.popupForm-bottom_buttons .next').on('click', function(){
        $('.popupForm-bottom_buttons').hide();
        $('.popupForm-bottom_buttonsForm').addClass('d-flex');

        $(".popupForm .step").hide();
        $(".popupForm .step-2").show();
        $(".popupForm .step-2").addClass('active');

        var getActive = parseInt($(".popupForm .step.active").attr('data-step'));

        $('.popupForm .popupFormNav .stepNav.active').last().next().addClass('active');
        $('.popupFormNav').attr('data-line', '2');


      })

      $('.popupForm-bottom_buttonsForm .next').on('click', function(){
        var getActive = parseInt($(".popupForm .step.active").attr('data-step'));
        var getActive = getActive + 1;
      
        if($('.popupForm .step.active').hasClass('last-step')) {
      
          // $('.wpcf7-submit').click();
            $('.popupFormContent .form2 .wpcf7-submit').click();
          
        } else {

          $('.popupFormNav').attr('data-line', '');
          $('.popupFormNav').attr('data-line', getActive);

          $('.popupForm .step').removeClass('active');
          $('.popupForm .step').hide();
          $('.popupForm .step[data-step="'+getActive+'"]').addClass('active');
          $('.popupForm .step[data-step="'+getActive+'"]').show();
        }

        $('.popupForm .popupFormNav .stepNav.active').last().next().addClass('active');

        if($('.popupForm .step.active').hasClass('last-step')) {
          $('.popupForm-bottom_buttonsForm .next').hide();
          $('.popupForm-bottom_buttonsForm .next.nextColor').show();

          
        } else {

        }
       
        setTimeout(function(){
        
            if($('form.wpcf7-form').hasClass('invalid')) {
              $('.stepNav.stepNav-6').removeClass('active');
            }
      
        }, 500);

      })

      $('.popupForm-bottom_buttonsForm .prev').on('click', function(){
        var getActive2 = parseInt($(".popupForm .step.active").attr('data-step'));

        if($('.popupForm .step.active').hasClass('last-step')) {
          $('.popupForm-bottom_buttonsForm .next').show();
          $('.popupForm-bottom_buttonsForm .next.nextColor').hide();
         
          
        } else {

      
        }
        
        if(getActive2 == 2) {
          $('.popupForm-bottom_buttonsForm').removeClass('d-flex');
          $('.popupForm-bottom_buttons').show();
          $('.popupForm .step').hide();
          $('.popupForm .step[data-step="1"]').show();
          $('.popupFormNav').attr('data-line', '');
          $('.popupFormNav').attr('data-line', '1');
          // $('.popupFormNav').attr('data-line', getActive2);
        } else {
          var getActive2 = getActive2 - 1;

          $('.popupFormNav').attr('data-line', '');
          $('.popupFormNav').attr('data-line', getActive2);

          $('.popupForm .step').removeClass('active');
          $('.popupForm .step').hide();
          $('.popupForm .step[data-step="'+getActive2+'"]').addClass('active');
          $('.popupForm .step[data-step="'+getActive2+'"]').show();
        }

        $('.popupForm .popupFormNav .stepNav.active').last().removeClass('active');


      })


      jQuery(".txtInput").on('keyup', function(){
        var value = jQuery(this).val().toLowerCase();
        jQuery(".singleQuestion-top h3").each(function () {
            if (jQuery(this).text().toLowerCase().search(value) > -1) {
                jQuery(this).closest('.singleQuestion').show();
                // $(this).prev('.subjectName').last().show();
                } else {
                jQuery(this).closest('.singleQuestion').hide();
            }
        });
    })

    document.addEventListener( 'wpcf7mailsent', function( event ) {
      if ( event.detail.contactFormId == '433' ) {
          console.log(event.detail);
          jQuery('div#wpcf7-f433-o3').hide();
          $('.stepNav-6').addClass('activeLast');
          $('.popupFormNav').attr('data-line', '6');
          $('.popupFormContent-thanks').show();
          $('.popupForm-bottom').hide();
          $('.agreeContent').remove();
          $('.form-pops').hide();
        }
      if ( event.detail.contactFormId == '1301' ) {
          console.log(event.detail);
          $(".popupForm .popupFormNav").remove();
          jQuery('#wpcf7-f1301-o3').hide();
          $('.stepNav-6').addClass('activeLast');
          $('.popupFormNav').attr('data-line', '6');
          $('.popupFormContent-thanks').show();
          $('.popupForm-bottom').hide();
          $('.agreeContent').remove();
          $('.form-pops').hide();
        }
    }, false );


    $('body.single-post .buttonSpis span').on('click', function(){
      $('body.single-post .post-content__table-of-contents').toggleClass('show')
    })




    // $(".faqContent .search-input .icon img").on('click', function(){
    //   $('.faqContent .search-input .inputElement input[type="submit"]').click();
    // })


    $('footer .navFooter h5').on('click', function(){
        var $submenu = $(this).next('ul');

        if ( ! $submenu.length ) {
            $submenu = $(this).next().find('ul');
        }

        if ( $(this).hasClass('active') ) {
            $(this).removeClass('active');
            $submenu.slideUp();
        } else {
            $('footer .navFooter h5').removeClass('active');
            $('footer .navFooter ul').slideUp();

            $(this).addClass('active');
            $submenu.slideDown();
        }
    })
    $('.popupForm .popupForm-bottom .popupForm-bottom_buttons button').addClass('disabled');
    $('input#zgoda').on('click', function(){
      if($('input#zgoda').is(':checked') == true){
        $('.popupForm .popupForm-bottom .popupForm-bottom_buttons button').removeClass('disabled');
      } else {
        $('.popupForm .popupForm-bottom .popupForm-bottom_buttons button').addClass('disabled');
      }
    })


if($('body').hasClass('single-kariera')) {
  $('.workList ul').each(function(){
    var icon = $(this).parent().attr('data-list');
    $(this).find('li').append('<img src="'+icon+'" />');
  })
}


jQuery('.popupFormContent .form2 input, .popupFormContent .form2 select').on('change', function(){
  var ValInt = jQuery(this).val();
  var name = jQuery(this).attr('name');
  console.log(name);  
  jQuery('.popupFormContent .form1 input[name="'+ name +'"], .popupFormContent .form1 select[name="'+ name +'"]').val(ValInt);
})

jQuery('.popupFormContent .form1 input, .popupFormContent .form1 select').on('change', function(){
  var ValInt = jQuery(this).val();
  var name = jQuery(this).attr('name');
  console.log(name);
  jQuery('.popupFormContent .form2 input[name="'+ name +'"], .popupFormContent .form2 select[name="'+ name +'"]').val(ValInt);
})


$('.popupForm .popupForm-bottom .popupForm-bottom_buttons .redirect').on('click', function(){
  $('.popupFormContent .form1 .wpcf7-submit').click();
  // $('.popupFormContent .form2 .wpcf7-submit').click();
})


$('.popupForm .popupForm-bottom .popupForm-bottom_buttons .redirect').on('mouseover', function(){
 $('.popupFormContent .form1').show(); 
 $('.popupFormContent .form2').hide(); 

 $('.form-pops').removeClass('active');
 $('.form1.form-pops').addClass('active');
})

$('.popupForm .popupForm-bottom .popupForm-bottom_buttons .next').on('mouseover', function(){
  $('.popupFormContent .form2').show(); 
  $('.popupFormContent .form1').hide(); 

  $('.form-pops').removeClass('active');
  $('.form2.form-pops').addClass('active');
 })
 



});





// Counter number 

if($(".sectionNumber").length > 0 ) {

var a = 0;
$(window).scroll(function () {
    var oTop = $(".sectionNumber").offset().top - window.innerHeight;
    if (a == 0 && $(window).scrollTop() > oTop) {
        $(".sectionNumber .singleNumber .number").each(function () {
            var $this = $(this),
                countTo = $this.attr("data-number");
            $({
                countNum: $this.text()
            }).animate(
                {
                    countNum: countTo
                },

                {
                    duration: 850,
                    easing: "swing",
                    step: function () {
                        //$this.text(Math.ceil(this.countNum));
                        $this.text(
                            Math.ceil(this.countNum).toLocaleString("pl")
                        );
                    },
                    complete: function () {
                        $this.text(
                            Math.ceil(this.countNum).toLocaleString("pl")
                        );
                        //alert('finished');
                    }
                }
            );
        });
        a = 1;
    }
});


}








});


